/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /*
   * <variant-contact-button>
   *
   * Swaps the add-to-cart / dynamic checkout buttons for a WhatsApp "request a
   * quote" CTA when the selected variant matches one of the admin-configured
   * names (e.g. gold variants priced on demand). Reacts to live variant changes
   * via the theme's `theme:variant:change` event. Configuration and the initial
   * state are rendered server-side by snippets/product-buttons.liquid.
   */
  if (!customElements.get('variant-contact-button')) {
    class VariantContactButton extends HTMLElement {
      connectedCallback() {
        this.container = this.closest('[data-section-type="product"]');
        this.link = this.querySelector('[data-contact-link]');
        this.emailLink = this.querySelector('[data-contact-email-link]');
        this.addToCartButton = this.querySelector('[data-add-to-cart]');

        this.names = (this.getAttribute('data-contact-names') || '')
          .split(',')
          .map(function (n) { return n.trim().toLowerCase(); })
          .filter(Boolean);
        this.digits = (this.getAttribute('data-whatsapp-number') || '').replace(/\D/g, '');
        this.messageTemplate = this.getAttribute('data-message-template') || '';
        this.email = (this.getAttribute('data-contact-email') || '').trim();
        this.emailSubjectTemplate = this.getAttribute('data-email-subject-template') || '';
        this.emailBodyTemplate = this.getAttribute('data-email-body-template') || '';

        // Fail safe: without a number or any names there is nothing to match,
        // so always leave the normal buy buttons visible.
        if (!this.digits || this.names.length === 0) {
          this.setContactState(false, null);
          return;
        }

        this.onVariantChange = this.onVariantChange.bind(this);
        if (this.container) {
          this.container.addEventListener('theme:variant:change', this.onVariantChange);
        }
      }

      disconnectedCallback() {
        if (this.container) {
          this.container.removeEventListener('theme:variant:change', this.onVariantChange);
        }
      }

      onVariantChange(event) {
        var variant = event && event.detail ? event.detail.variant : null;

        // No selectable variant (e.g. unavailable combination) -> show buy buttons.
        if (!variant) {
          this.setContactState(false, null);
          return;
        }

        var haystack = String(variant.title || '');
        if (Array.isArray(variant.options)) {
          haystack += ' ' + variant.options.join(' ');
        }
        haystack = haystack.toLowerCase();

        var isContact = this.names.some(function (name) {
          return haystack.indexOf(name) !== -1;
        });

        this.setContactState(isContact, variant.title);
      }

      setContactState(isContact, variantTitle) {
        // State lives on the product container so the price block, the cart-bar price and
        // the buy buttons (separate siblings) all toggle from a single shared ancestor.
        if (this.container) {
          this.container.classList.toggle('is-contact-variant', isContact);
        }

        if (this.addToCartButton) {
          // Prevent the hidden form from submitting while in contact mode; when
          // leaving contact mode let the theme manage availability itself.
          this.addToCartButton.disabled = isContact;
        }

        if (isContact && this.link && variantTitle != null) {
          var message = this.messageTemplate.split('%%VARIANT%%').join(variantTitle);
          this.link.setAttribute(
            'href',
            'https://wa.me/' + this.digits + '?text=' + encodeURIComponent(message)
          );
        }

        if (isContact && this.emailLink && this.email && variantTitle != null) {
          var subject = this.emailSubjectTemplate.split('%%VARIANT%%').join(variantTitle);
          var body = this.emailBodyTemplate.split('%%VARIANT%%').join(variantTitle);
          this.emailLink.setAttribute(
            'href',
            'mailto:' + this.email +
              '?subject=' + encodeURIComponent(subject) +
              '&body=' + encodeURIComponent(body)
          );
        }
      }
    }

    customElements.define('variant-contact-button', VariantContactButton);
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
